/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.InteracMoneyRequestResponse,
  InteracMoneyRequest: (params: vp.InteracMoneyRequestRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostInteracMoneyRequest: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldInteracMoneyRequest, setShouldInteracMoneyRequest] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.InteracMoneyRequestRequest>({
    PortalUser: '',
    Amount: 0,
    Currency: '',
    EmailAddress: '',
    RecipientName: '',
    MessageForRecipient: '',
    ClientReferenceNumber: '',
    Notes: '',
    ClientAccountID: '',
    GenerateURL: false,
  });
  const [response, setResponse] = useState<vp.InteracMoneyRequestResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
    TransactionStatus: '',
  });

  useEffect(() => {
    if (!shouldInteracMoneyRequest) return () => {};

    const PostInteracMoneyRequest = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postInteracMoneyRequest(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldInteracMoneyRequest) void PostInteracMoneyRequest();
    setShouldInteracMoneyRequest(false);
    return () => {
      source.cancel();
    };
  }, [shouldInteracMoneyRequest]);

  return [
    response,
    (_params: vp.InteracMoneyRequestRequest) => {
      setParams(_params);
      setShouldInteracMoneyRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
        TransactionStatus: '',
      });
      setShouldInteracMoneyRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostInteracMoneyRequest);
